import { render, staticRenderFns } from "./VenueScoreStatusButton.vue?vue&type=template&id=810a835c&scoped=true&"
import script from "./VenueScoreStatusButton.vue?vue&type=script&lang=js&"
export * from "./VenueScoreStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./VenueScoreStatusButton.vue?vue&type=style&index=0&id=810a835c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810a835c",
  null
  
)

export default component.exports